import React from "react";

import { CardTagLabel } from "./CardTagLabel";
import styles from "./NestingCard.scss";
import { TagType } from "./types";

export function CardTags({ tags }: { tags: TagType[] }) {
  return (
    <>
      {tags.map((tag, index) => (
        <div
          className={styles["card-tags"]}
          data-testid={`card-tags-${index}`}
          key={index}
        >
          <CardTagLabel
            key={index}
            text={tag.text}
            textProps={tag?.textProps}
            icon={tag?.icon}
          />
        </div>
      ))}
    </>
  );
}
